import React from 'react';

import { ROUTES } from '../../../../utils/routes';
import type { RequiredModule, UserSection } from './types';

export const createRequiredModules = (navigate: (route: string) => void): RequiredModule[] => [
  {
    id: 'required-copro-list',
    icon: <span role="img" aria-label="building">🏢</span>,
    title: 'Sélection des immeubles à fort potentiel pour le boitage',
    route: ROUTES.PROSPECTING_BOITAGE_QUALIFICATION,
    onClick: () => navigate(ROUTES.PROSPECTING_BOITAGE_QUALIFICATION),
  },
  {
    id: 'required-sci-overview',
    icon: <span role="img" aria-label="analytics">📈</span>,
    title: 'SCI : Module de qualification des SCI',
    route: ROUTES.MONITORING_SCIS_OVERALL,
    onClick: () => navigate(ROUTES.MONITORING_SCIS_OVERALL),
  },
  {
    id: 'ag-documents',
    icon: <span role="img" aria-label="document">📄</span>,
    title: 'Date AG à qualifier et Document à imprimer par immeuble et à mettre sur les tables lors des AG',
    route: ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER,
    onClick: () => navigate(ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER),
  },
  {
    id: 'required-page-site',
    icon: <span role="img" aria-label="globe">🌐</span>,
    title: 'Lien vers le blog des articles à inclure sur votre site',
    route: ROUTES.COMMUNICATION_PAGE_SITE,
    onClick: () => navigate(ROUTES.COMMUNICATION_PAGE_SITE),
  },
  {
    id: 'required-training',
    icon: <span role="img" aria-label="calendar">🗓️</span>,
    title: 'Role et mission / formation / argumentaire',
    route: ROUTES.COMMUNICATION_REFERENT_FORMATION,
    onClick: () => navigate(ROUTES.COMMUNICATION_REFERENT_FORMATION),
  },
];

export const createUserSections = (navigate: (route: string) => void): UserSection[] => [
  {
    id: 'referent',
    title: 'RÉFÉRENT MUTATION LOCATION (et son assistant[e])',
    icon: <span role="img" aria-label="person">👤</span>,
    description: 'Modules pour le référent mutation/location et son équipe',
    roleDescription: 'Le référent mutation location a pour mission d\'éviter le détournement de finalité des données personnelles, en étant le point de contact dédié pour tous les projets de transaction et location des copropriétaires.',
    collapsed: true,
    modules: [
      {
        id: 'newsletters',
        icon: <span role="img" aria-label="email">📧</span>,
        number: 'MODULE 1 RÉFÉRENT',
        title: 'LES NEWSLETTER à envoyer tous les trimestres',
        shortDesc: '4 newsletters RGPD compatibles par an qui informent vos copropriétaires et positionnent votre référent comme expert pour favoriser la prise de contact en cas de vente ou de location',
        fullDesc: '4 newsletters expertes par an (DPE, Vente, Location, Travaux) qui éduquent vos copropriétaires et positionnent votre référent comme expert incontournable.',
        route: ROUTES.COMMUNICATION_NEWSLETTER_LIST,
        onClick: () => navigate(ROUTES.COMMUNICATION_NEWSLETTER_LIST),
        planningRowKey: 'newsletter',
        planningEventType: 'newsletter',
        planningEventKeys: ['Newsletter 1', 'Newsletter 2', 'Newsletter 3', 'Newsletter 4'],
        planningDateLabels: ['T1 – Trimestre 1', 'T2 – Trimestre 2', 'T3 – Trimestre 3', 'T4 – Trimestre 4'],
      },
      {
        id: 'referent-campaigns',
        icon: <span role="img" aria-label="person">👤</span>,
        number: 'MODULE 2 RÉFÉRENT',
        title: 'Les 2 campagnes par an SUR LE RÉFÉRENT',
        shortDesc: 'Modèles pour les 2 campagnes annuelles de communication sur le référent.',
        fullDesc: 'Modèles pour les 2 campagnes annuelles de communication.',
        route: ROUTES.COMMUNICATION_REFERENT_CAMPAIGNS,
        onClick: () => navigate(ROUTES.COMMUNICATION_REFERENT_CAMPAIGNS),
        planningRowKey: 'referent-mails',
        planningEventType: 'referent',
        planningEventKeys: ['Référent 1', 'Référent 2'],
        planningDateLabels: ['Campagne 1', 'Campagne 2'],
      },
      {
        id: 'sci-referent',
        icon: <span role="img" aria-label="office building">🏢</span>,
        number: 'MODULE 3 RÉFÉRENT',
        title: 'SCI : module de qualification des SCI cibles et modèles des 2 campagnes de mails/an',
        shortDesc: 'Identification des SCI présentes sur votre parc et prospection par 2 campagnes par an sur la transaction et/ou la gestion locative.',
        fullDesc: 'Identification des SCI présentes sur votre parc et prospection par 2 campagnes par an sur la transaction et/ou la gestion locative.',
        disabled: false,
        route: ROUTES.PROSPECTING_SCIS_REFERENT,
        onClick: () => navigate(ROUTES.PROSPECTING_SCIS_REFERENT),
        planningRowKey: 'sci-mails',
        planningEventType: 'sci-referent',
        planningEventKeys: ['SCI 1', 'SCI 2'],
        planningDateLabels: ['Campagne SCI 1', 'Campagne SCI 2'],
      },
      {
        id: 'building-selection',
        icon: <span role="img" aria-label="target">🎯</span>,
        number: 'MODULE 4 RÉFÉRENT',
        title: 'Boitage dans les immeubles à fort potentiel',
        shortDesc: 'Outils d\'analyse et de boitage des immeubles les plus prometteurs pour vos actions de prospection.',
        fullDesc: 'Outils d\'analyse et de boitage des immeubles les plus prometteurs pour vos actions de prospection.',
        disabled: false,
        route: ROUTES.PROSPECTING_BOITAGE_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_BOITAGE_TRANSACTION),
        planningRowKey: 'boitage',
        planningEventType: 'boitage',
        planningEventKeys: ['Boîtage 1', 'Boîtage 2'],
        planningDateLabels: ['Boîtage 1', 'Boîtage 2'],
      },
      {
        id: 'dpe-detection',
        icon: <span role="img" aria-label="chart">📊</span>,
        number: 'MODULE 5 RÉFÉRENT',
        title: 'LES DPE DU PARC / traitement des nouvelles opportunités à la semaine',
        shortDesc: 'Détection automatique chaque mercredi des nouveaux DPE dans vos copropriétés pour identifier les projets de vente et de location.',
        fullDesc: 'Détection automatique chaque mercredi des nouveaux DPE dans vos copropriétés pour identifier les projets de vente et de location.',
        route: ROUTES.PROSPECTING_NEW_OPPORTUNITIES,
        onClick: () => navigate(ROUTES.PROSPECTING_NEW_OPPORTUNITIES),
        planningRowKey: 'dpe',
        planningFrequencyBadge: 'Tous les mercredis — Traitement hebdomadaire automatique',
      },
      {
        id: 'ag-presence',
        icon: <span role="img" aria-label="speaking head">🗣️</span>,
        number: 'MODULE 6 RÉFÉRENT',
        title: 'AG : module de sélection des AG où être présent (le plus de transactions) et documents à imprimer pour les AG',
        shortDesc: 'Documents éditables pour optimiser votre communication pendant les assemblées générales et sélection des AG à fort potentiel de transactions.',
        fullDesc: 'Documents éditables pour optimiser votre communication pendant les assemblées générales.',
        route: ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_REFERENT,
        onClick: () => navigate(ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_REFERENT),
        planningRowKey: 'ag-communication',
        planningNoDateNote: 'Aucune date fixe prédéfinie — géré directement par le responsable selon le calendrier des AG.',
      },
      {
        id: 'building-communication',
        icon: <span role="img" aria-label="house">🏠</span>,
        number: 'MODULE 7 RÉFÉRENT',
        title: 'Communiquez sur les BIENS À VENDRE DANS L\'IMMEUBLE (modèle de communication par le boitage)',
        shortDesc: 'Modèles de communication par boîtage pour informer les copropriétaires de vos mandats dans leur immeuble.',
        fullDesc: 'Modèles de communication par boîtage pour informer les copropriétaires de vos mandats dans leur immeuble.',
        disabled: false,
        route: ROUTES.PROSPECTING_SCIS_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_SCIS_TRANSACTION),
        planningRowKey: 'property-communication',
        planningNoDateNote: 'Aucune date fixe prédéfinie — géré à chaque nouveau mandat par le responsable.',
      },
    ],
  },
  {
    id: 'transaction',
    title: 'SERVICE TRANSACTION',
    icon: <span role="img" aria-label="briefcase">💼</span>,
    description: 'Modules pour le service transaction',
    roleDescription: 'Mission : Convertir les leads générés par le référent en mandats de vente.',
    collapsed: true,
    modules: [
      {
        id: 'transaction-appointments',
        icon: <span role="img" aria-label="clipboard">📋</span>,
        number: 'MODULE 1 SERVICE TRANSACTION',
        title: 'Les chiffres clés des copropriétés / Rapports et avis de valeur',
        shortDesc: 'Les chiffres clés des copropriétés / Rapports et avis de valeur',
        fullDesc: 'Les chiffres clés des copropriétés / Rapports et avis de valeur.',
        disabled: false,
        route: ROUTES.PROSPECTING_COPRO_KEY_FIGURES,
        onClick: () => navigate(ROUTES.PROSPECTING_COPRO_KEY_FIGURES),
      },
      {
        id: 'transaction-communication',
        icon: <span role="img" aria-label="house">🏠</span>,
        number: 'MODULE 2 SERVICE TRANSACTION',
        title: 'Communication sur un bien à vendre dans l\'immeuble',
        shortDesc: 'Modèles de mails et courriers pour informer les copropriétaires de vos biens à vendre dans leur immeuble',
        fullDesc: 'Modèles de mails et courriers pour informer les copropriétaires de vos biens à vendre dans leur immeuble.',
        disabled: false,
        route: ROUTES.PROSPECTING_SCIS_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_SCIS_TRANSACTION),
      },
      {
        id: 'transaction-boitage',
        icon: <span role="img" aria-label="open mailbox with raised flag">📬</span>,
        number: 'MODULE 3 SERVICE TRANSACTION',
        title: 'Boitage : sélection des immeubles à fort potentiel et modèles à distribuer',
        shortDesc: 'Outils de sélection d\'immeubles à fort potentiel et modèles de documents pour les actions de boîtage ciblées',
        fullDesc: 'Outils de sélection d\'immeubles à fort potentiel et modèles de documents pour les actions de boîtage ciblées.',
        disabled: false,
        route: ROUTES.PROSPECTING_BOITAGE_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_BOITAGE_TRANSACTION),
      },
    ],
  },
  {
    id: 'gestion-locative',
    title: 'SERVICE GESTION LOCATIVE',
    icon: <span role="img" aria-label="house">🏠</span>,
    description: 'Modules pour le service gestion locative',
    roleDescription: 'Mission : Développer le portefeuille de gestion locative grâce aux prospects du référent.',
    collapsed: true,
    modules: [
      {
        id: 'sci-rental',
        icon: <span role="img" aria-label="office building">🏢</span>,
        number: 'MODULE 1 SERVICE GESTION LOCATIVE',
        title: 'SCI : communication pour leur proposer le service de gestion locative',
        shortDesc: 'Modèles de mails et courriers spécialement adaptés pour proposer vos services aux SCI',
        fullDesc: 'Modèles de mails et courriers spécialement adaptés pour proposer vos services aux SCI.',
        disabled: false,
        route: ROUTES.PROSPECTING_SCIS_RENT,
        onClick: () => navigate(ROUTES.PROSPECTING_SCIS_RENT),
      },
      {
        id: 'surveillance-gestion-locative',
        icon: <span role="img" aria-label="eye">👁️</span>,
        number: 'MODULE 2 SERVICE GESTION LOCATIVE',
        title: 'Surveillance gestion locative',
        shortDesc: 'Surveillance des entreprises de votre choix via les publications BODACC',
        fullDesc: 'Suivez spécifiquement les entreprises de votre choix en surveillant leurs publications au BODACC pour anticiper les risques.',
        disabled: false,
        route: ROUTES.MONITORING_ENTREPRISES_SUIVIES,
        onClick: () => navigate(ROUTES.MONITORING_ENTREPRISES_SUIVIES),
      },
    ],
  },
  {
    id: 'gestionnaires',
    title: 'GESTIONNAIRES DE L\'IMMEUBLE',
    icon: <span role="img" aria-label="building">🏢</span>,
    description: 'Modules pour les gestionnaires d\'immeuble et assistants',
    roleDescription: 'Mission : Accompagner la gestion quotidienne des immeubles, préparer les documents d\'assemblée générale et faciliter le travail du référent mutation-location.',
    collapsed: true,
    modules: [
      {
        id: 'gestionnaire-ag',
        icon: <span role="img" aria-label="document">📄</span>,
        number: 'MODULE 1 GESTIONNAIRES',
        title: 'Date AG à qualifier et Documents à imprimer pour les AG',
        shortDesc: 'Documents à imprimer par immeuble et à disposer sur les tables lors des assemblées générales.',
        fullDesc: 'Documents à imprimer par immeuble et à disposer sur les tables lors des assemblées générales.',
        route: ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER,
        onClick: () => navigate(ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER),
        planningRowKey: 'ag-communication',
        planningNoDateNote: 'Aucune date fixe prédéfinie — géré directement selon le calendrier des AG.',
      },
    ],
  },
  {
    id: 'agences-partenaires',
    title: 'MODULES POUR LES AGENCES PARTENAIRES',
    icon: <span role="img" aria-label="handshake">🤝</span>,
    description: 'Modules pour les agences partenaires',
    roleDescription: 'Mission : Collaboration efficace avec accès aux leads qualifiés du référent.',
    collapsed: true,
    modules: [
      {
        id: 'transaction-appointments',
        icon: <span role="img" aria-label="clipboard">📋</span>,
        number: 'MODULE 1 SERVICE TRANSACTION',
        title: 'Les chiffres clés des copropriétés / Rapports et avis de valeur',
        shortDesc: 'Les chiffres clés des copropriétés / Rapports et avis de valeur',
        fullDesc: 'Les chiffres clés des copropriétés / Rapports et avis de valeur.',
        disabled: false,
        route: ROUTES.PROSPECTING_COPRO_KEY_FIGURES,
        onClick: () => navigate(ROUTES.PROSPECTING_COPRO_KEY_FIGURES),
      },
      {
        id: 'partner-communication',
        icon: <span role="img" aria-label="house">🏠</span>,
        number: 'MODULE 2 AGENCES PARTENAIRES',
        title: 'Communication sur un bien à vendre dans l\'immeuble',
        shortDesc: 'Modèles de mails et courriers adaptés pour les agences partenaires',
        fullDesc: 'Modèles de mails et courriers adaptés pour les agences partenaires.',
        disabled: false,
        route: ROUTES.PROSPECTING_SCIS_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_SCIS_TRANSACTION),
      },
      {
        id: 'partner-boitage',
        icon: <span role="img" aria-label="open mailbox with raised flag">📬</span>,
        number: 'MODULE 3 AGENCES PARTENAIRES',
        title: 'Boitage : sélection des immeubles à fort potentiel et modèles à distribuer',
        shortDesc: 'Outils de sélection d\'immeubles à fort potentiel et modèles de documents pour les actions de boîtage partenaires',
        fullDesc: 'Outils de sélection d\'immeubles à fort potentiel et modèles de documents pour les actions de boîtage partenaires.',
        disabled: false,
        route: ROUTES.PROSPECTING_BOITAGE_TRANSACTION,
        onClick: () => navigate(ROUTES.PROSPECTING_BOITAGE_TRANSACTION),
      },
    ],
  },
];

export function getReferentPlanningRowKeys(sections: UserSection[]): string[] {
  const referentSection = sections.find((s) => s.id === 'referent');
  if (!referentSection) { return []; }
  return referentSection.modules
    .map((m) => m.planningRowKey)
    .filter((key): key is string => Boolean(key));
}
